import { ErrorStateScheduleEnum } from '../error-state-schedule.enum';

export enum TradingPlanFormErrorStatesEnum {
    CreatePlanFailed = ErrorStateScheduleEnum.TradingPlanFormStatesStartIndex,
    UpdatePlanFailed, 
}
